module.exports = __webpack_public_path__ + "img/transformer.2c0156f7.svg";